import {
  Backdrop, Button, Card, CardActions, CardContent, Typography
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import axios from 'src/utils/axios';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Alert from 'src/components/Alert';
import './imagePreview.css';
import { saveFotograf } from 'src/utils/storage/StrPhoto';
import { useTranslation } from 'react-i18next';

const Compress = require('compress.js');

const compress = new Compress();


const useStyles = makeStyles((theme) => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));


function urltoFile(url, filename, mimeType) {
  return (fetch(url)
    .then((res) => res.arrayBuffer())
    .then((buf) => new File([buf], filename, { type: mimeType }))
  );
}


export const ImagePreview = ({
  className, onClose, dataUri, ReceiptNo, DosyaTipi, DosyaTipiText, isFullscreen
}) => {
  const classNameFullscreen = isFullscreen ? 'demo-image-preview-fullscreen' : '';
  const classes = useStyles();
  const [Loading, setLoading] = useState(false);

  const [uyari, setUyari] = React.useState(false);
  const { t } = useTranslation('work_order');


  const MerkezeGonder = (event) => {
    urltoFile(dataUri, DosyaTipiText, 'image/png')
      .then(async (filelar) => {
        const file = filelar;
        const FileType = file.type;

        let base64Result = '';

        const resizedImage = await compress.compress([file], {
          size: 0.3,
          quality: 1,
          maxWidth: 1920,
          maxHeight: 1920,
          resize: true
        });
        const img = resizedImage[0];
        base64Result = img.data;


        setLoading(true);
        // now upload
        const data = {
          Title: DosyaTipiText,
          MIMEType: FileType,
          WorkOrderId: ReceiptNo,
          FileType: DosyaTipi,
          FileData: base64Result
        };
        const config = {
          headers: { 'Content-Type': 'application/json' }
        };


        if (window.navigator.onLine) {
          await axios.post('/FileImportExport/SiriusFileUpload', data, config)
            // eslint-disable-next-line
            .then(response => {
              onClose(dataUri);
              setLoading(false);
            }).catch((error) => {
              saveFotograf(ReceiptNo, dataUri, DosyaTipi, DosyaTipiText, FileType);
              setLoading(false);
              onClose(dataUri);
            });
        } else {
          saveFotograf(ReceiptNo, dataUri, DosyaTipi, DosyaTipiText, FileType);
          setLoading(false);
          onClose(dataUri);
        }
      });
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  return (
    <Card className={clsx(classes.root, className)}>
      <CardActions>
        <Button
          variant="contained"
          color="primary"
          onClick={MerkezeGonder}
          className={classes.submitButton}
          endIcon={<SendIcon />}
        >
          {t('lblEkle')}
        </Button>
      </CardActions>
      <CardContent className={classes.content}>
        {
          Loading
            ? (
              <Backdrop className={classes.backdrop} open={Loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
            )
            : <div />
        }
        <Typography variant="h6" gutterBottom>
          {ReceiptNo}
          {' '}
          {DosyaTipiText}
        </Typography>
        <div className={`demo-image-preview ${classNameFullscreen}`}>
          <img src={dataUri} alt="" />
        </div>
        {
          uyari
            ? <Alert onClose={handleClose} message={t('lblBasarili')} variant="success" />
            : <div />
        }
      </CardContent>
    </Card>

  );
};

ImagePreview.propTypes = {
  dataUri: PropTypes.string,
  isFullscreen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ImagePreview;
